import { Component, Prop, Vue, Mixins } from 'vue-property-decorator';
import store from "Store/index";

@Component({
    template: '#user-login-template'
})
export default class UserComponent extends Vue {

    
}

Vue.component('user-login', UserComponent);